import { ToObject } from "./262.mjs";
function CoerceOptionsToObject(options) {
  if (typeof options === "undefined") {
    return /* @__PURE__ */ Object.create(null);
  }
  return ToObject(options);
}
export {
  CoerceOptionsToObject
};
